// store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';

import { createAppListeners } from '@/store/listeners';
import { rootReducer } from '@/store/rootReducer';
import { createJsonServices } from '@/services/createJsonServices';
import { registerBeforeUnloadHandler } from '@/utils/beforeUnloadCleanup';

// Create services instance
const services = createJsonServices();
const { listenerMiddleware } = createAppListeners(services);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: {
        extraArgument: services
      }

    }).prepend(listenerMiddleware.middleware),
});

registerBeforeUnloadHandler(() => services);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
